// extracted by mini-css-extract-plugin
module.exports = {"noResults":"RegularNoResults_noResults__2QUiE"};